// Address - components > address
export const ADDRESS_FIELDS = {
  registrationAddress: 'Postcode',
  registrationAddressOne: 'Address Line 1',
  registrationAddressTwo: 'Address Line 2',
  registrationCity: 'City',
};
export const BILLING_ADDRESS = {
  enterAddressManually: 'Enter address manually?',
  lookupOrEnterAddress: 'Lookup address or enter one manually',
  registerPostcodeDoesntExist: `The postcode you entered doesn't exist. Please enter your address manually below`,
  registrationEirCode: 'Eircode',
  registrationLookupError:
    'An error occurred looking up your postcode. Please enter your address manually.',
};
export const BILLING_ADDRESS_ONLY_POSTCODE = {
  lookupOrEnterAddress: 'Lookup address or enter one manually',
  registrationEirCode: 'Eircode',
};
export const BILLING_ADDRESS_AUTOCOMPLETE = {
  enterAddressManually: 'Enter address manually?',
  lookupOrEnterAddress: 'Lookup address or enter one manually',
  registerAddressDoesntExist: `The address you entered doesn't exist. Please enter your address manually below`,
  registrationEirCode: 'Eircode',
  registrationLookupError:
    'An error occurred looking up your postcode. Please enter your address manually.',
};
export const LOOKUP_ADDRESS_COMP = {
  lookupAddress: 'Lookup address',
  registrationAddress: 'Postcode',
};
export const LOOKUP_ADDRESS_AUTOCOMPLETE = {
  prompt: 'Start typing an address...',
};
export const LOOKUP_VERIFY_POSTCODE = {
  registrationAddressPlaceholder: 'Postcode',
};
